const SEX_TYPE = {
  MAN: '010601',
  WOMAN: '010602',
};

export default SEX_TYPE;



// WEBPACK FOOTER //
// ./src/constants/sexType.js